import { CloudDownloadOutlined } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import { getAllHelpItems } from '../../redux/api/userMgt';

const Help = () => {
    const [processing, setProcessing] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [records, setRecords] = useState([]);
    const { enqueueSnackbar } = useSnackbar();

    const columns = [
        {
            field: 'sn',
            headerName: 'S/N',
            width: 80,
            sortable: false,
            renderCell: (params) => {
                return <p style={{ margin: 'auto' }}>{(params?.api?.getRowIndex(params?.row?.id) || 0) + 1}</p>;
            },
        },
        {
            field: 'id',
            headerName: 'Quick Action',
            width: 150,
            sortable: false,
            renderCell: (params) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <IconButton size="small" color="primary" onClick={() => {}} title="Download File">
                        <CloudDownloadOutlined />
                    </IconButton>
                </div>
            ),
        },
        { field: 'name', headerName: 'Name', width: 300 },
    ];

    const init = async () => {
        try {
            setProcessing(true);
            const res = await getAllHelpItems();
            setRecords(res?.resultObject || []);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    useEffect(() => {
        // init();
    }, []);

    return (
        <PageContainer pageTitle="Help" processing={processing}>
            <Box>
                <div className="paper wrapper" style={{ height: 500, width: '100%', textAlign: 'center' }}>
                    <DataGrid
                        className={'center-first-column'}
                        rows={[]}
                        getRowId={(row) => row.id}
                        columns={columns}
                        rowHeight={'65px'}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        checkboxSelection={false}
                        disableSelectionOnClick
                        style={{ fontSize: '12px' }}
                    />
                </div>
            </Box>
        </PageContainer>
    );
};

export default Help;
